webpackJsonp([1],{

/***/ "+Al0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/happy.a84d295.png";

/***/ }),

/***/ "/qur":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cool.d93d74d.png";

/***/ }),

/***/ "6HYP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/meh.270c9f2.png";

/***/ }),

/***/ "BAqc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EPpO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H+Vd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'App'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7ec843c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("BAqc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loader.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loader = ({
  name: 'loader'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-410bfe5f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader.vue
var loader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var loader_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('span',{staticClass:"blob1 blob"}),_vm._v(" "),_c('span',{staticClass:"blob2 blob"}),_vm._v(" "),_c('span',{staticClass:"blob3 blob"})])}]
var loader_esExports = { render: loader_render, staticRenderFns: loader_staticRenderFns }
/* harmony default export */ var components_loader = (loader_esExports);
// CONCATENATED MODULE: ./src/components/loader.vue
function loader_injectStyle (ssrContext) {
  __webpack_require__("SrNG")
}
var loader_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var loader___vue_template_functional__ = false
/* styles */
var loader___vue_styles__ = loader_injectStyle
/* scopeId */
var loader___vue_scopeId__ = "data-v-410bfe5f"
/* moduleIdentifier (server only) */
var loader___vue_module_identifier__ = null
var loader_Component = loader_normalizeComponent(
  loader,
  components_loader,
  loader___vue_template_functional__,
  loader___vue_styles__,
  loader___vue_scopeId__,
  loader___vue_module_identifier__
)

/* harmony default export */ var src_components_loader = (loader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var login = ({
  name: 'login',
  data: function data() {
    var access_token = this.$route.hash.substring(1);
    return {
      results: null,
      errors: [],
      access_token: access_token,
      showLoading: false
    };
  },

  components: {
    'blob-loader': src_components_loader
  },
  methods: {
    getHashParams: function getHashParams() {
      var hashParams = {};
      var e,
          r = /([^&;=]+)=?([^&;]*)/g,
          q = window.location.hash.substring(1);
      while (e = r.exec(q)) {
        hashParams[e[1]] = decodeURIComponent(e[2]);
      }
      return hashParams;
    },
    generateRandomString: function generateRandomString(length) {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    authorize: function authorize(stateKey) {
      var client_id = '2acb1bf4bb054c3a9d24c0256833c1a7'; // Your client id
      //  var redirect_uri = 'http://localhost:8080/authorize'; // Your redirect uri TEST
      var redirect_uri = 'https://moodify-app.firebaseapp.com/authorize'; // Your redirect uri PROD
      var state = this.generateRandomString(16);
      localStorage.setItem(stateKey, state);
      var scope = 'user-read-private user-read-email';
      var url = 'https://accounts.spotify.com/authorize';
      url += '?response_type=token';
      url += '&client_id=' + encodeURIComponent(client_id);
      url += '&scope=' + encodeURIComponent(scope);
      url += '&redirect_uri=' + encodeURIComponent(redirect_uri);
      url += '&state=' + encodeURIComponent(state);
      window.location = url;
    },
    login: function login() {

      // show loading animation
      this.showLoading = true;

      // display login information 
      var userProfileSource = document.getElementById('user-profile-template').innerHTML,

      //  userProfileTemplate = Handlebars.compile(userProfileSource),
      userProfilePlaceholder = document.getElementById('user-profile');
      var oauthSource = document.getElementById('oauth-template').innerHTML,

      //  oauthTemplate = Handlebars.compile(oauthSource),
      oauthPlaceholder = document.getElementById('oauth');

      var stateKey = "spotify_auth_state";
      var params = this.getHashParams();
      var storedState = localStorage.getItem(stateKey);
      if (this.access_token.length > 0 && (params.state == null || params.state !== storedState)) {
        alert("There was an error during the authentication");
      } else {
        localStorage.removeItem(stateKey);
        if (this.access_token.length > 0) {
          axios.get({
            url: "https://api.spotify.com/v1/me",
            headers: {
              Authorization: "Bearer " + access_token
            },
            success: function success(response) {
              userProfilePlaceholder.innerHTML = userProfileTemplate(response);
              //  window.location.replace("http://localhost:8080/authorize") // TEST
              window.location.replace("http://moodify-app.firebaseapp.com/authorize"); // PROD
            }
          });
        } else {
          console.log("Authentication needed, retreiving access token.");
        }
      }
      this.authorize(stateKey);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c1d2cee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('h1',[_vm._v("Moodify")]),_vm._v(" "),_c('p',[_vm._v("Music to suit your mood.")]),_vm._v(" "),_c('p',[_vm._v("You must log in to Spotify to use this app.")]),_vm._v(" "),_c('button',{attrs:{"id":"login-button"},on:{"click":_vm.login}},[_vm._v("LOG IN")]),_vm._v(" "),(_vm.showLoading)?_c('blob-loader'):_vm._e()],1)}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('div',{attrs:{"id":"user-profile-template"}}),_vm._v(" "),_c('div',{attrs:{"id":"user-profile"}}),_vm._v(" "),_c('div',{attrs:{"id":"oauth-template"}}),_vm._v(" "),_c('div',{attrs:{"id":"oauth"}})])}]
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var components_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("Q5v9")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-4c1d2cee"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  login,
  components_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_components_login = (login_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/moodslider.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var moodslider = ({
  name: 'moodslider',
  data: function data() {
    return {
      moods: {
        happy: {
          src: __webpack_require__("+Al0"),
          text: "happy"
        },
        love: {
          src: __webpack_require__("dyV4"),
          text: "love"
        },
        silly: {
          src: __webpack_require__("Zqf7"),
          text: "silly"
        },
        surprise: {
          src: __webpack_require__("rcH9"),
          text: "surprise"
        },
        cool: {
          src: __webpack_require__("/qur"),
          text: "cool"
        },
        sleepy: {
          src: __webpack_require__("izrj"),
          text: "sleepy"
        },
        meh: {
          src: __webpack_require__("6HYP"),
          text: "meh"
        },
        sad: {
          src: __webpack_require__("iC7B"),
          text: "sad"
        }
      }
    };
  },

  methods: {
    selectMood: function selectMood(event) {
      this.$emit('selected', event.currentTarget.childNodes[0].alt);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395e0d04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/moodslider.vue
var moodslider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.moods),function(mood){return _c('ul',[_c('li',{on:{"click":_vm.selectMood}},[_c('img',{attrs:{"src":mood.src,"alt":mood.text}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(mood.text))])])])}))}
var moodslider_staticRenderFns = []
var moodslider_esExports = { render: moodslider_render, staticRenderFns: moodslider_staticRenderFns }
/* harmony default export */ var components_moodslider = (moodslider_esExports);
// CONCATENATED MODULE: ./src/components/moodslider.vue
function moodslider_injectStyle (ssrContext) {
  __webpack_require__("NJ0j")
}
var moodslider_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var moodslider___vue_template_functional__ = false
/* styles */
var moodslider___vue_styles__ = moodslider_injectStyle
/* scopeId */
var moodslider___vue_scopeId__ = "data-v-395e0d04"
/* moduleIdentifier (server only) */
var moodslider___vue_module_identifier__ = null
var moodslider_Component = moodslider_normalizeComponent(
  moodslider,
  components_moodslider,
  moodslider___vue_template_functional__,
  moodslider___vue_styles__,
  moodslider___vue_scopeId__,
  moodslider___vue_module_identifier__
)

/* harmony default export */ var src_components_moodslider = (moodslider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/moodify.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var moodify = ({
  name: 'moodify',
  data: function data() {
    var access_token = this.$route.hash.substring(1);
    return {
      results: [],
      errors: [],
      query: '______',
      access_token: access_token,
      showLoading: false
    };
  },

  mounted: function mounted() {
    if (this.$ls.get === undefined) {
      // if no token, redirect to Login
      this.router.push("login");
    } else {
      // go to moodify
    }
  },
  components: {
    'mood-slider': src_components_moodslider,
    'blob-loader': src_components_loader
  },
  methods: { //Return list of playlists
    getPlaylist: function getPlaylist(someValue) {
      var _this = this;

      // clear errors 
      this.errors = [];
      // clear previous playlists
      this.results = [];
      // show blob loading animation
      this.showLoading = true;
      // API call
      console.log(someValue);
      this.query = someValue;
      var config = {
        headers: {
          Authorization: "Bearer ".concat(this.$ls.get("accessToken"))
        }
      };
      var URL = 'https://api.spotify.com/v1/search?type=playlist&q=' + this.query;
      var self = this;
      axios_default.a.get(URL, config).then(function (response) {
        self.results = response.data.playlists.items;
        // turn off loader
        _this.showLoading = false;
      }).catch(function (error) {
        _this.errors.push(error);
        // turn off loader
        _this.showLoading = false;
      });
    },
    moodifyOpenPlaylist: function moodifyOpenPlaylist() {
      this.$ga.event('button-moodify', 'click', 'playlist-moodify', '1');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81d65eb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/moodify.vue
var moodify_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"loggedIn"}},[_c('h1',[_vm._v("Moodify")]),_vm._v(" "),_c('p',[_vm._v("Music to suit your mood.")]),_vm._v(" "),_c('p',[_vm._v("Here are some "+_vm._s(_vm.query)+" playlists.")]),_vm._v(" "),_c('mood-slider',{on:{"selected":_vm.getPlaylist}}),_vm._v(" "),(_vm.showLoading)?_c('blob-loader'):_vm._e(),_vm._v(" "),(_vm.errors && _vm.errors.length > 0)?_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_c('p',{attrs:{"id":"error"}},[_vm._v("Error: "+_vm._s(error.response.data.error.status)+" - "+_vm._s(error.response.data.error.message))])])})):_vm._e(),_vm._v(" "),(_vm.results && _vm.results.length > 0)?_c('ul',_vm._l((_vm.results),function(result){return _c('li',[_c('p',[_vm._v(_vm._s(result.name))]),_vm._v(" "),_c('p',[_vm._v("There are "+_vm._s(result.tracks.total)+" tracks in this playlist.")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"target":"_blank","href":result.external_urls.spotify},on:{"click":_vm.moodifyOpenPlaylist}},[_vm._v("Listen to tracks")]),_vm._v(" "),_c('router-link',{staticClass:"button",attrs:{"id":"playlistLink","to":{name: 'tracks', params: { URL: result.tracks.href, openURL: result.external_urls.spotify }}}},[_vm._v("Display tracks")]),_vm._v(" "),_c('hr')],1)})):_vm._e()],1)])}
var moodify_staticRenderFns = []
var moodify_esExports = { render: moodify_render, staticRenderFns: moodify_staticRenderFns }
/* harmony default export */ var components_moodify = (moodify_esExports);
// CONCATENATED MODULE: ./src/components/moodify.vue
function moodify_injectStyle (ssrContext) {
  __webpack_require__("EPpO")
}
var moodify_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var moodify___vue_template_functional__ = false
/* styles */
var moodify___vue_styles__ = moodify_injectStyle
/* scopeId */
var moodify___vue_scopeId__ = "data-v-81d65eb8"
/* moduleIdentifier (server only) */
var moodify___vue_module_identifier__ = null
var moodify_Component = moodify_normalizeComponent(
  moodify,
  components_moodify,
  moodify___vue_template_functional__,
  moodify___vue_styles__,
  moodify___vue_scopeId__,
  moodify___vue_module_identifier__
)

/* harmony default export */ var src_components_moodify = (moodify_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/authorize.vue
//
//
//
//
//
//

/* harmony default export */ var authorize = ({
  name: 'authorize',
  created: function created() {
    console.log("Authorization token created");
  },
  data: function data() {
    var hash2Obj = location.hash.split("&").map(function (el) {
      return el.split("=");
    }).reduce(function (pre, cur) {
      pre[cur[0]] = cur[1];
      return pre;
    }, {});
    var accessCode = hash2Obj["#access_token"];
    this.$ls.set('accessToken', accessCode, 60 * 60 * 1000); // set auth token to expire in one hour
    this.$router.push({ path: "/moodify#" + accessCode });
    return {};
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f10f5b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authorize.vue
var authorize_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var authorize_staticRenderFns = []
var authorize_esExports = { render: authorize_render, staticRenderFns: authorize_staticRenderFns }
/* harmony default export */ var components_authorize = (authorize_esExports);
// CONCATENATED MODULE: ./src/components/authorize.vue
var authorize_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var authorize___vue_template_functional__ = false
/* styles */
var authorize___vue_styles__ = null
/* scopeId */
var authorize___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var authorize___vue_module_identifier__ = null
var authorize_Component = authorize_normalizeComponent(
  authorize,
  components_authorize,
  authorize___vue_template_functional__,
  authorize___vue_styles__,
  authorize___vue_scopeId__,
  authorize___vue_module_identifier__
)

/* harmony default export */ var src_components_authorize = (authorize_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/tracks.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var tracks = ({
  name: 'tracks',
  data: function data() {
    return {
      lists: [],
      errors: [],
      URL: this.$route.params.URL,
      openURL: this.$route.params.openURL,
      showLoading: true
    };
  },

  components: {
    'blob-loader': src_components_loader
  },
  mounted: function mounted() {
    var _this = this;

    console.log(this.URL);
    var config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer ".concat(this.$ls.get('accessToken')),
        "Content-Type": "application/json"
      }
    };
    axios_default.a
    // pass URL definition from data
    .get(this.URL, config).then(function (response) {
      _this.lists = response.data.items;
      // turn off loader
      _this.showLoading = false;
    }).catch(function (error) {
      _this.errors.push(error);
      // turn off loader
      _this.showLoading = false;
    });
  },
  methods: {
    tracksOpenPlaylist: function tracksOpenPlaylist() {
      this.$ga.event('button-tracks', 'click', 'playlist-tracks', '1');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06562b0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tracks.vue
var tracks_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Moodify")]),_vm._v(" "),_c('p',[_vm._v("Music to suit your mood.")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"target":"_blank","href":this.openURL},on:{"click":_vm.tracksOpenPlaylist}},[_vm._v("Listen to tracks")]),_vm._v(" "),_c('router-link',{staticClass:"button",attrs:{"to":"/moodify"}},[_vm._v("Pick another playlist")]),_vm._v(" "),(_vm.showLoading)?_c('blob-loader'):_vm._e(),_vm._v(" "),(_vm.errors && _vm.errors.length > 0)?_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_c('p',{attrs:{"id":"error"}},[_vm._v("Error: "+_vm._s(error.response.status)+" - "+_vm._s(error.response.statusText))])])})):_vm._e(),_vm._v(" "),(_vm.lists && _vm.lists.length > 0)?_c('ul',_vm._l((_vm.lists),function(list){return _c('li',[_c('p',[_vm._v(_vm._s(list.track.name)+" - "+_vm._s(list.track.artists[0].name))])])})):_vm._e()],1)}
var tracks_staticRenderFns = []
var tracks_esExports = { render: tracks_render, staticRenderFns: tracks_staticRenderFns }
/* harmony default export */ var components_tracks = (tracks_esExports);
// CONCATENATED MODULE: ./src/components/tracks.vue
function tracks_injectStyle (ssrContext) {
  __webpack_require__("H+Vd")
}
var tracks_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var tracks___vue_template_functional__ = false
/* styles */
var tracks___vue_styles__ = tracks_injectStyle
/* scopeId */
var tracks___vue_scopeId__ = "data-v-06562b0e"
/* moduleIdentifier (server only) */
var tracks___vue_module_identifier__ = null
var tracks_Component = tracks_normalizeComponent(
  tracks,
  components_tracks,
  tracks___vue_template_functional__,
  tracks___vue_styles__,
  tracks___vue_scopeId__,
  tracks___vue_module_identifier__
)

/* harmony default export */ var src_components_tracks = (tracks_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js







vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'login',
    component: src_components_login
  }, {
    path: '/moodify',
    name: 'moodify',
    component: src_components_moodify
  }, {
    path: '/authorize',
    name: 'authorize',
    component: src_components_authorize
  }, {
    path: '/tracks/:URL/:openURL',
    name: 'tracks',
    component: src_components_tracks
  }]
}));
// EXTERNAL MODULE: ./node_modules/vue-ls/dist/vue-ls.js
var vue_ls = __webpack_require__("yXtV");
var vue_ls_default = /*#__PURE__*/__webpack_require__.n(vue_ls);

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/es6-promise/dist/es6-promise.js
var es6_promise = __webpack_require__("hKoQ");
var es6_promise_default = /*#__PURE__*/__webpack_require__.n(es6_promise);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// to work with IE 11
es6_promise_default.a.polyfill();

var options = {
  namespace: 'auth___',
  name: 'ls',
  storage: 'local'
};

vue_esm["a" /* default */].use(vue_ls_default.a, options);

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-124672993-1',
  autotracking: {
    exception: true
  },
  router: router
});

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "NJ0j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q5v9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SrNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zqf7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/silly.61b3572.png";

/***/ }),

/***/ "dyV4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/love.531943f.png";

/***/ }),

/***/ "iC7B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sad.27b92c1.png";

/***/ }),

/***/ "izrj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sleepy.8f3694c.png";

/***/ }),

/***/ "rcH9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/surprised.8dae223.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.dd93d5671aa55b20b2e8.js